import React from 'react';
import Typography from '@clasohlson/co-ui-components/Typography';
// import { useTranslation } from 'react-i18next';
import { useTranslation } from '../utils';
import customTheme from '../theme';

export const ErrorPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Typography variant="h3" tag="h3" color={customTheme.colors.primary}>
        {t('generalError')}
      </Typography>
    </div>
  );
};
